
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 120 37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55.398 29.633h-5.534L53.323 8.38h5.533l-3.458 21.253zM45.209 8.38l-5.275 14.618-.624-3.148v.001l-1.862-9.558s-.225-1.913-2.625-1.913h-8.72L26 8.74s2.667.555 5.788 2.429l4.808 18.465h5.765L51.164 8.38H45.21zm43.523 21.253h5.081L89.383 8.38h-4.448c-2.054 0-2.554 1.584-2.554 1.584l-8.253 19.67h5.768l1.154-3.157h7.034l.648 3.157zm-6.089-7.518l2.908-7.953 1.635 7.953h-4.543zm-8.082-8.624l.79-4.564S72.913 8 70.373 8c-2.746 0-9.267 1.2-9.267 7.036 0 5.49 7.653 5.559 7.653 8.443 0 2.884-6.865 2.367-9.13.549l-.823 4.772s2.47 1.2 6.246 1.2c3.776 0 9.472-1.955 9.472-7.276 0-5.526-7.722-6.041-7.722-8.444 0-2.403 5.39-2.094 7.758-.79z","fill":"#E6E7E9"}}),_c('path',{attrs:{"d":"M39.31 19.851l-1.862-9.558s-.225-1.914-2.625-1.914h-8.72L26 8.74s4.192.869 8.212 4.124c3.845 3.11 5.098 6.988 5.098 6.988z","fill":"#E6E7E9"}})])
          )
        }
      }
    